var _circle, _rect, _circle2, _circle3, _g, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _circle4, _circle5, _g2, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _circle6, _circle7, _g3, _rect14, _rect15, _rect16, _rect17, _rect18, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEmptyChat = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 266,
    height: 264,
    viewBox: "0 0 266 264",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 132.664,
    cy: 132,
    r: 132,
    fill: "#F3F3F3"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_27442_112470)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.66406,
    y: 18,
    width: 254,
    height: 60,
    rx: 4,
    fill: "white",
    shapeRendering: "crispEdges"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 38.6641,
    cy: 48,
    r: 19,
    fill: "#D4E8EC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_27442_112470",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 29,
    width: 39,
    height: 38
  }, _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 38.6641,
    cy: 48,
    r: 19,
    fill: "#D4E8EB"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_27442_112470)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.1646 57.5C57.4219 58.1108 57.1375 60.9298 56.6645 65C56.1916 69.0702 49.0462 73.3746 43.7889 72.7637C42.8195 72.6511 35.3587 71.9955 34.5017 71.6847C30.7109 70.3095 29.653 73.5952 32.153 66.0952C32.5232 62.9088 34.8883 59.6036 38.6646 59C42.4408 58.3964 46.1645 56 52.1646 57.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.7946 63.2792C40.527 62.2602 40.7921 59.4238 41.2081 58.1329C42.3463 56.0755 44.7414 52.1383 45.216 52.8488C45.8093 53.7369 49.6803 56.8218 49.487 59.3038C49.1773 63.2791 45.6292 64.5529 42.7946 63.2792Z",
    fill: "#FFD4B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.0097 53.5503C48.0097 58.4721 44.0198 62.462 39.098 62.462C34.1762 62.462 30.1863 58.4721 30.1863 53.5503C30.1863 52.6428 29.9342 45.6809 30.1863 44.8559C31.3016 41.2067 35.5184 39.8567 39.5327 39.8567C43.3858 39.8567 46.233 44.2582 47.4766 47.6816C47.8216 48.6311 48.0097 52.4816 48.0097 53.5503Z",
    fill: "#FFDBC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9194 52.8941C48.9194 57.8159 44.9295 61.8058 40.0076 61.8058C35.0858 61.8058 31.0959 57.8159 31.0959 52.8941C31.0959 51.9866 30.8438 45.0247 31.096 44.1997C32.2112 40.5505 36.4281 39.2004 40.4424 39.2004C44.2955 39.2004 47.1427 43.602 48.3863 47.0254C48.7313 47.9749 48.9194 51.8253 48.9194 52.8941Z",
    fill: "#FBC49C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2398 50.8499C36.7647 51.3249 36.2595 54.0266 36.7647 55.1249C37.27 56.2231 38.6647 56.5499 39.8556 55.9413",
    stroke: "#E29C69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1394 58.9247C41.5144 60.3498 44.3645 57.9748 43.8894 56.0747",
    stroke: "#B85757",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 33.9144,
    cy: 51.7999,
    rx: 0.95,
    ry: 0.95,
    fill: "black"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 33.2691,
    cy: 48.9832,
    rx: 2.1526,
    ry: 0.838736,
    transform: "rotate(3.90778 33.2691 48.9832)",
    fill: "black"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 40.5838,
    cy: 47.4971,
    rx: 1.73887,
    ry: 0.824422,
    transform: "rotate(-21.1896 40.5838 47.4971)",
    fill: "black"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 40.5647,
    cy: 49.9,
    rx: 0.95,
    ry: 0.95,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.165 49.4998C30.165 46.1964 30.8375 46.4761 30.665 45.4998C28.2614 41.9999 27.9322 43.2453 27.6649 45.4998C27.4395 47.4016 27.5528 53.0699 29.165 55C30.4546 56.544 30.5781 57.6036 31.165 57.4999C30.6553 55.6434 30.165 50.9275 30.165 49.4998Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5576 46.6189C46.3851 45.0634 45.0607 43.213 44.4201 42.4821C45.6285 42.5668 48.3679 43.0502 49.6584 44.3067C51.2714 45.8773 51.9157 49.5236 50.5211 52.0839C49.4054 54.1321 47.5473 54.8194 46.7577 54.907C46.7629 52.7924 46.7302 48.1743 46.5576 46.6189Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6647 50.0001C45.1648 43.5001 43.6044 42.8615 40.1648 43.5001C34.6648 44.5212 33.4307 46.2838 30.0745 46.8123C27.2648 47.2547 25.3848 46.1629 24.4148 44.6748C23.5934 43.4147 24.2566 41.5903 26.5628 41.8468C25.3538 40.1966 24.4503 38.0368 27.2648 38.9749C32.4898 38.9749 34.8484 38.2537 37.2397 37.55C39.6898 36.8289 44.8648 34.6427 47.6898 38.9749C48.2871 39.8909 48.4851 40.5714 48.3729 41.0745C52.9207 45.9648 50.0145 51.862 46.6647 50.0001Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6891 50.8497C29.5987 50.5271 30.5892 50.7712 30.5892 52.7497C30.5892 54.7282 31.1999 56.7041 30.8968 56.5428C30.5178 56.3411 29.0019 55.9379 28.4966 54.7282C27.9913 53.5184 27.5522 51.253 28.6891 50.8497Z",
    fill: "#FBC49C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4281 47.1011C46.8631 46.7533 45.8922 48.2603 45.6024 49.0573C45.3851 50.5064 45.0807 53.361 45.6024 53.1871C46.2545 52.9698 48.8628 52.535 49.7322 51.2309C50.6017 49.9267 50.3843 47.5358 48.4281 47.1011Z",
    fill: "#FBC49C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.0766 49.619C48.7358 48.6135 47.3138 48.6006 46.9814 49.2736",
    stroke: "#CA9A77",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1143 52.7498C29.639 52.7497 29.3961 52.9006 29.1639 53.2248",
    stroke: "#CA9A77",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 33.7056,
    cy: 55.5269,
    rx: 1.11628,
    ry: 0.95,
    fill: "#EC8969"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.9844,
    cy: 52.6768,
    rx: 1.11628,
    ry: 0.95,
    fill: "#EC8969"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 67.6641,
    y: 34.6428,
    width: 45,
    height: 5.57143,
    fill: "#D9D9D9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 67.6641,
    y: 45.2144,
    width: 32,
    height: 5.57143,
    fill: "#D9D9D9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 67.6641,
    y: 55.7856,
    width: 23,
    height: 5.57143,
    fill: "#D9D9D9"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 206.093,
    y: 30.2144,
    width: 35.5713,
    height: 35.5713,
    fill: "url(#pattern0)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 4.16406,
    y: 18.5,
    width: 253,
    height: 59,
    rx: 3.5,
    stroke: "#D1D1D1",
    shapeRendering: "crispEdges"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_27442_112470)"
  }, _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 3.66406,
    y: 95,
    width: 254,
    height: 60,
    rx: 4,
    fill: "white",
    shapeRendering: "crispEdges"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 38.6641,
    cy: 125,
    r: 19,
    fill: "#EFD0DB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_27442_112470",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 106,
    width: 39,
    height: 38
  }, _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 38.6641,
    cy: 125,
    r: 19,
    fill: "#EFD0DB"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_27442_112470)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.1646 134.5C57.4219 135.111 57.1375 137.93 56.6645 142C56.1916 146.07 49.0462 150.375 43.7889 149.764C42.8195 149.651 35.3587 148.996 34.5017 148.685C30.7109 147.309 29.653 150.595 32.153 143.095C32.5232 139.909 34.8883 136.604 38.6646 136C42.4408 135.396 46.1645 133 52.1646 134.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.7946 140.279C40.527 139.26 40.7921 136.424 41.2081 135.133C42.3463 133.076 44.7414 129.138 45.216 129.849C45.8093 130.737 49.6803 133.822 49.487 136.304C49.1773 140.279 45.6292 141.553 42.7946 140.279Z",
    fill: "#FFD4B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.0097 130.55C48.0097 135.472 44.0198 139.462 39.098 139.462C34.1762 139.462 30.1863 135.472 30.1863 130.55C30.1863 129.643 29.9342 122.681 30.1863 121.856C31.3016 118.207 35.5184 116.857 39.5327 116.857C43.3858 116.857 46.233 121.258 47.4766 124.682C47.8216 125.631 48.0097 129.482 48.0097 130.55Z",
    fill: "#FFDBC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9194 129.894C48.9194 134.816 44.9295 138.806 40.0076 138.806C35.0858 138.806 31.0959 134.816 31.0959 129.894C31.0959 128.987 30.8438 122.025 31.096 121.2C32.2112 117.55 36.4281 116.2 40.4424 116.2C44.2955 116.2 47.1427 120.602 48.3863 124.025C48.7313 124.975 48.9194 128.825 48.9194 129.894Z",
    fill: "#FBC49C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2398 127.85C36.7647 128.325 36.2595 131.027 36.7647 132.125C37.27 133.223 38.6647 133.55 39.8556 132.941",
    stroke: "#E29C69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1394 135.925C41.5144 137.35 44.3645 134.975 43.8894 133.075",
    stroke: "#B85757",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 33.9144,
    cy: 128.8,
    rx: 0.95,
    ry: 0.95,
    fill: "black"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 33.2691,
    cy: 125.983,
    rx: 2.1526,
    ry: 0.838736,
    transform: "rotate(3.90778 33.2691 125.983)",
    fill: "black"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 40.5838,
    cy: 124.497,
    rx: 1.73887,
    ry: 0.824422,
    transform: "rotate(-21.1896 40.5838 124.497)",
    fill: "black"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 40.5647,
    cy: 126.9,
    rx: 0.95,
    ry: 0.95,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.165 126.5C30.165 123.196 30.8375 123.476 30.665 122.5C28.2614 119 27.9322 120.245 27.6649 122.5C27.4395 124.402 27.5528 130.07 29.165 132C30.4546 133.544 30.5781 134.604 31.165 134.5C30.6553 132.643 30.165 127.928 30.165 126.5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5576 123.619C46.3851 122.063 45.0607 120.213 44.4201 119.482C45.6285 119.567 48.3679 120.05 49.6584 121.307C51.2714 122.877 51.9157 126.524 50.5211 129.084C49.4054 131.132 47.5473 131.819 46.7577 131.907C46.7629 129.792 46.7302 125.174 46.5576 123.619Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6647 127C45.1648 120.5 43.6044 119.862 40.1648 120.5C34.6648 121.521 33.4307 123.284 30.0745 123.812C27.2648 124.255 25.3848 123.163 24.4148 121.675C23.5934 120.415 24.2566 118.59 26.5628 118.847C25.3538 117.197 24.4503 115.037 27.2648 115.975C32.4898 115.975 34.8484 115.254 37.2397 114.55C39.6898 113.829 44.8648 111.643 47.6898 115.975C48.2871 116.891 48.4851 117.571 48.3729 118.074C52.9207 122.965 50.0145 128.862 46.6647 127Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6891 127.85C29.5987 127.527 30.5892 127.771 30.5892 129.75C30.5892 131.728 31.1999 133.704 30.8968 133.543C30.5178 133.341 29.0019 132.938 28.4966 131.728C27.9913 130.518 27.5522 128.253 28.6891 127.85Z",
    fill: "#FBC49C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4281 124.101C46.8631 123.753 45.8922 125.26 45.6024 126.057C45.3851 127.506 45.0807 130.361 45.6024 130.187C46.2545 129.97 48.8628 129.535 49.7322 128.231C50.6017 126.927 50.3843 124.536 48.4281 124.101Z",
    fill: "#FBC49C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.0766 126.619C48.7358 125.613 47.3138 125.601 46.9814 126.274",
    stroke: "#CA9A77",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1143 129.75C29.639 129.75 29.3961 129.901 29.1639 130.225",
    stroke: "#CA9A77",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 33.7056,
    cy: 132.527,
    rx: 1.11628,
    ry: 0.95,
    fill: "#EC8969"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.9844,
    cy: 129.677,
    rx: 1.11628,
    ry: 0.95,
    fill: "#EC8969"
  }))), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 67.6641,
    y: 111.643,
    width: 45,
    height: 5.57143,
    fill: "#D9D9D9"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 67.6641,
    y: 122.214,
    width: 32,
    height: 5.57143,
    fill: "#D9D9D9"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 67.6641,
    y: 132.786,
    width: 23,
    height: 5.57143,
    fill: "#D9D9D9"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 206.093,
    y: 107.214,
    width: 35.5713,
    height: 35.5713,
    fill: "url(#pattern1)"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 4.16406,
    y: 95.5,
    width: 253,
    height: 59,
    rx: 3.5,
    stroke: "#D1D1D1",
    shapeRendering: "crispEdges"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_27442_112470)"
  }, _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 3.66406,
    y: 172,
    width: 254,
    height: 60,
    rx: 4,
    fill: "white",
    shapeRendering: "crispEdges"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 38.6641,
    cy: 202,
    r: 19,
    fill: "#D9ECD4"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_27442_112470",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 183,
    width: 39,
    height: 38
  }, _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 38.6641,
    cy: 202,
    r: 19,
    fill: "#D4E8EB"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_27442_112470)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.1646 211.5C57.4219 212.111 57.1375 214.93 56.6645 219C56.1916 223.07 49.0462 227.375 43.7889 226.764C42.8195 226.651 35.3587 225.996 34.5017 225.685C30.7109 224.309 29.653 227.595 32.153 220.095C32.5232 216.909 34.8883 213.604 38.6646 213C42.4408 212.396 46.1645 210 52.1646 211.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.7946 217.279C40.527 216.26 40.7921 213.424 41.2081 212.133C42.3463 210.076 44.7414 206.138 45.216 206.849C45.8093 207.737 49.6803 210.822 49.487 213.304C49.1773 217.279 45.6292 218.553 42.7946 217.279Z",
    fill: "#FFD4B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.0097 207.55C48.0097 212.472 44.0198 216.462 39.098 216.462C34.1762 216.462 30.1863 212.472 30.1863 207.55C30.1863 206.643 29.9342 199.681 30.1863 198.856C31.3016 195.207 35.5184 193.857 39.5327 193.857C43.3858 193.857 46.233 198.258 47.4766 201.682C47.8216 202.631 48.0097 206.482 48.0097 207.55Z",
    fill: "#FFDBC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9194 206.894C48.9194 211.816 44.9295 215.806 40.0076 215.806C35.0858 215.806 31.0959 211.816 31.0959 206.894C31.0959 205.987 30.8438 199.025 31.096 198.2C32.2112 194.55 36.4281 193.2 40.4424 193.2C44.2955 193.2 47.1427 197.602 48.3863 201.025C48.7313 201.975 48.9194 205.825 48.9194 206.894Z",
    fill: "#FBC49C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2398 204.85C36.7647 205.325 36.2595 208.027 36.7647 209.125C37.27 210.223 38.6647 210.55 39.8556 209.941",
    stroke: "#E29C69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1394 212.925C41.5144 214.35 44.3645 211.975 43.8894 210.075",
    stroke: "#B85757",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 33.9144,
    cy: 205.8,
    rx: 0.95,
    ry: 0.95,
    fill: "black"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 33.2691,
    cy: 202.983,
    rx: 2.1526,
    ry: 0.838736,
    transform: "rotate(3.90778 33.2691 202.983)",
    fill: "black"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 40.5838,
    cy: 201.497,
    rx: 1.73887,
    ry: 0.824422,
    transform: "rotate(-21.1896 40.5838 201.497)",
    fill: "black"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 40.5647,
    cy: 203.9,
    rx: 0.95,
    ry: 0.95,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.165 203.5C30.165 200.196 30.8375 200.476 30.665 199.5C28.2614 196 27.9322 197.245 27.6649 199.5C27.4395 201.402 27.5528 207.07 29.165 209C30.4546 210.544 30.5781 211.604 31.165 211.5C30.6553 209.643 30.165 204.928 30.165 203.5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5576 200.619C46.3851 199.063 45.0607 197.213 44.4201 196.482C45.6285 196.567 48.3679 197.05 49.6584 198.307C51.2714 199.877 51.9157 203.524 50.5211 206.084C49.4054 208.132 47.5473 208.819 46.7577 208.907C46.7629 206.792 46.7302 202.174 46.5576 200.619Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6647 204C45.1648 197.5 43.6044 196.862 40.1648 197.5C34.6648 198.521 33.4307 200.284 30.0745 200.812C27.2648 201.255 25.3848 200.163 24.4148 198.675C23.5934 197.415 24.2566 195.59 26.5628 195.847C25.3538 194.197 24.4503 192.037 27.2648 192.975C32.4898 192.975 34.8484 192.254 37.2397 191.55C39.6898 190.829 44.8648 188.643 47.6898 192.975C48.2871 193.891 48.4851 194.571 48.3729 195.074C52.9207 199.965 50.0145 205.862 46.6647 204Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6891 204.85C29.5987 204.527 30.5892 204.771 30.5892 206.75C30.5892 208.728 31.1999 210.704 30.8968 210.543C30.5178 210.341 29.0019 209.938 28.4966 208.728C27.9913 207.518 27.5522 205.253 28.6891 204.85Z",
    fill: "#FBC49C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4281 201.101C46.8631 200.753 45.8922 202.26 45.6024 203.057C45.3851 204.506 45.0807 207.361 45.6024 207.187C46.2545 206.97 48.8628 206.535 49.7322 205.231C50.6017 203.927 50.3843 201.536 48.4281 201.101Z",
    fill: "#FBC49C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.0766 203.619C48.7358 202.613 47.3138 202.601 46.9814 203.274",
    stroke: "#CA9A77",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1143 206.75C29.639 206.75 29.3961 206.901 29.1639 207.225",
    stroke: "#CA9A77",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 33.7056,
    cy: 209.527,
    rx: 1.11628,
    ry: 0.95,
    fill: "#EC8969"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.9844,
    cy: 206.677,
    rx: 1.11628,
    ry: 0.95,
    fill: "#EC8969"
  }))), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 67.6641,
    y: 188.643,
    width: 45,
    height: 5.57143,
    fill: "#D9D9D9"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 67.6641,
    y: 199.214,
    width: 32,
    height: 5.57143,
    fill: "#D9D9D9"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 67.6641,
    y: 209.786,
    width: 23,
    height: 5.57143,
    fill: "#D9D9D9"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 206.093,
    y: 184.214,
    width: 35.5713,
    height: 35.5713,
    fill: "url(#pattern2)"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 4.16406,
    y: 172.5,
    width: 253,
    height: 59,
    rx: 3.5,
    stroke: "#D1D1D1",
    shapeRendering: "crispEdges"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_27442_112470",
    x: 3.66406,
    y: 18,
    width: 262,
    height: 68,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_27442_112470"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_27442_112470",
    result: "shape"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_27442_112470",
    transform: "scale(0.0104167)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_27442_112470",
    x: 3.66406,
    y: 95,
    width: 262,
    height: 68,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_27442_112470"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_27442_112470",
    result: "shape"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern1",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_27442_112470",
    transform: "scale(0.0104167)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_27442_112470",
    x: 3.66406,
    y: 172,
    width: 262,
    height: 68,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_27442_112470"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_27442_112470",
    result: "shape"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern2",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_27442_112470",
    transform: "scale(0.0104167)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_27442_112470",
    width: 96,
    height: 96,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAABmJLR0QA/wD/AP+gvaeTAAAA+UlEQVR4nO3aUQqCUBRFUYvmP+WaQQpW++Vd67vE2jxITtsGAAAAwBS3A695fv0uzjnyGZZ1r29gOgFiAsQEiAkQEyAmQOzxgWvs/Q7fe444+/6/5gTEBIgJEBMgJkBMgJgAsSvsAat7+x07ATEBYgLEBIgJEBMgJkDsCntA/b+gU89JTkBMgJgAMQFiAsQEiAkQm7AHLP2c4gTEBIgJEBMgJkBMgJgAMXtAvCc4ATEBYgLEBIgJEBMgJkDMHmAPmE2AmAAxAWICxASICRCzB9gDZhMgJkBMgJgAMQFiAsQm7AE1e8DKBIgJEBMgJkBMgJgAAAAAAPAjL43oEpi8V6NjAAAAAElFTkSuQmCC"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEmptyChat);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/empty_chat.5de26a1004b316e52dadd997a812ea20.svg";